import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Privacy.css'; // Optional if you have styles for the privacy page

const Privacy = () => {
  return (
    <>
    <Navbar />
    <div className='privacy-container'>
      <h1>Privacy Policy</h1>
      
      <h2>What Information We Collect</h2>
      <p>
        When you sign up for our service, we collect only the following information:
      </p>
      <ul>
        <li><strong>Username:</strong> An alias of your choosing to identify your account</li>
        <li><strong>Password:</strong> For secure access to your account</li>
      </ul>
      <p>
        We do <strong>not</strong> collect email addresses, real names, or any other personally identifiable information. 
        Once you're registered and using the site, we collect health measurements that you voluntarily enter on a daily 
        basis such as your mood, anxiety levels, and other wellness data.
        <br/><br/>
        <strong>Important:</strong> There is no password recovery option available. If you forget your password, you will 
        need to create a new account. We recommend keeping your password in a secure location.
        <br/><br/>
        This site uses cookies. Cookies are small pieces of information that are sent back and forth between our website 
        and your computing device to distinguish you from other users. We use cookies to simplify the process of 
        establishing a session when you log into your account. As long as you are logged in and interacting with the 
        site, a cookie is being sent back and forth to your computer.
      </p>
      
      <h2>How We Use Your Information</h2>
      <p>
        The information we collect is used solely to:
      </p>
      <ul>
        <li>Identify you as a user of the website through your chosen username</li>
        <li>Organize and present your health data back to you (e.g., creating charts from your anxiety levels)</li>
        <li>Maintain your session while you use the application</li>
      </ul>
      <p>
        We may disclose aggregated, non-personally identifying information to third parties. For example, we may share 
        statistics about the number of site visitors or general usage patterns within a given period of time. This 
        aggregate information may be disclosed to other users of the site or to current or potential business partners. 
        No personally identifying information is ever disclosed because we don't collect any.
        <br/><br/>
        If OCDSerenity is sold or acquired by a third party, that third party will abide by this privacy policy.
      </p>
      
      <h2>Data Security and HIPAA Compliance</h2>
      <p>
        We are fully HIPAA compliant and take data protection seriously. All data is encrypted and securely stored 
        through our Business Associate Agreement (BAA) with Google Cloud Services. Your health information is protected 
        using industry-standard security measures.
      </p>
      
      <h2>Your Privacy Options</h2>
      <p>
        Since we only collect your username and the health data you choose to enter, your privacy is protected by design. 
        You can use any alias as your username to further protect your identity. 
        <br/><br/>
        You may request to delete your account and all associated data by{' '}
        <a href='mailto:contact@ocdserenity.com'>contacting us</a>. Upon account deletion, all your data will be 
        permanently removed from our systems.
      </p>
      
      <h2>Changes to this Privacy Policy</h2>
      <p>
        We may occasionally update this policy to reflect changes in our practices or to comply with current laws and 
        regulations. We reserve the right to change this policy at any time. Any updates will be posted on this page.
      </p>
      
    </div>
    <Footer />
    </>
  );
};

export default Privacy;